export default "__VITE_ASSET__BBjdM7Fx__"